import apiClient from '../client';
import { AxiosError } from 'axios';
import { Customer } from '@shared/types/Customer';

export interface UploadResult {
  message: string;
  ordersImported: number;
}

export interface ValidationError {
  row: number;
  column: string;
  message: string;
}

export interface ValidationFailure {
  isValidation: true;
  message: string;
  errors: ValidationError[];
}

export const orderImportService = {
  getEdiCustomers: async (): Promise<Customer[]> => {
    const response: any = await apiClient.get('/customers/edi-integration');
    return response.data;
  },

  uploadCSV: async (customerId: string, file: File): Promise<UploadResult | ValidationFailure> => {
    const formData = new FormData();
    formData.append('customerId', customerId);
    formData.append('csvFile', file);

    try {
      const response = await apiClient.post<{ success: boolean; message: string; ordersImported?: number; errors?: ValidationError[] }>(
        '/order-import/upload',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          validateStatus: (status) => status < 500,
        }
      );

      if (response.status === 400 && response.data.errors) {
        return {
          isValidation: true,
          message: response.data.message,
          errors: response.data.errors,
        };
      }

      if (response.status >= 400) {
        throw new Error(response.data.message ?? 'Upload failed');
      }

      return {
        message: response.data.message,
        ordersImported: response.data.ordersImported ?? 0,
      };
    } catch (err) {
      if (err instanceof Error && !(err as AxiosError).isAxiosError) throw err;
      const axiosErr = err as AxiosError<{ message?: string }>;
      throw new Error(axiosErr.response?.data?.message ?? axiosErr.message ?? 'Upload failed');
    }
  },
};
